import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ModuloDeclaracao, VerificarAutenticidadeService } from './verificar-autenticidade.service';

@Component({
  selector: 'app-verificar-autenticidade',
  templateUrl: './verificar-autenticidade.component.html',
  styleUrls: ['./verificar-autenticidade.component.css']
})
export class VerificarAutenticidadeComponent implements OnInit {
  verificacaoForm: UntypedFormGroup;

  verificandoLoading = false;
  downloadLoading = false;

  resultadoVisible = false;
  declaracaoValida = false;

  detalhesVerificacao: any = null;

  get modulo(): ModuloDeclaracao {
    return this.verificacaoForm.get('modulo')?.value || 'pad';
  }

  get declaracaoInfo(): any {
    return this.detalhesVerificacao?.certidao || this.detalhesVerificacao?.declaracao;
  }

  get codigoExibido(): string {
    return this.declaracaoInfo?.codigo || this.verificacaoForm.get('codigo')?.value || '';
  }

  get tipoDeclaracaoLabel(): string {
    const tipo = this.declaracaoInfo?.tipo;
    const sufixo = this.modulo === 'tac' ? 'TAC' : 'PAD';
    if (tipo === 'positiva') {
      return `Declaração Positiva de ${sufixo}`;
    }
    if (tipo === 'negativa') {
      return `Declaração Negativa de ${sufixo}`;
    }
    return tipo ? String(tipo) : '';
  }

  formatarCpf(cpf: string): string {
    const numeros = String(cpf || '').replace(/\D/g, '');
    if (numeros.length !== 11) {
      return cpf || '';
    }
    return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  constructor(
    private fb: UntypedFormBuilder,
    private verificarAutenticidadeService: VerificarAutenticidadeService,
    private snackBar: SnackBarService
  ) {
    this.verificacaoForm = this.fb.group({
      modulo: ['pad' as ModuloDeclaracao, Validators.required],
      codigo: [null, [Validators.required, Validators.pattern(/^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/)]]
    });
  }

  ngOnInit(): void {}

  onModuloChange(): void {
    this.resultadoVisible = false;
    this.declaracaoValida = false;
    this.detalhesVerificacao = null;
  }

  formatarCodigo(event: any) {
    const input = event.target;
    let value = input.value.replace(/[^A-Za-z0-9-]/g, '').toUpperCase();
    value = value.replace(/-/g, '');

    if (value.length > 16) {
      value = value.substring(0, 16);
    }

    if (value.length > 0) {
      let formattedValue = '';
      for (let i = 0; i < value.length; i++) {
        if (i > 0 && i % 4 === 0 && i < 16) {
          formattedValue += '-';
        }
        formattedValue += value[i];
      }
      value = formattedValue;
    }

    this.verificacaoForm.get('codigo').setValue(value, { emitEvent: false });
  }

  verificarAutenticidade() {
    if (this.verificacaoForm.invalid) {
      this.snackBar.showSnackBarError('Por favor, insira um código válido no formato XXXX-XXXX-XXXX-XXXX');
      return;
    }

    const codigo = this.verificacaoForm.get('codigo').value;
    this.verificandoLoading = true;
    this.resultadoVisible = false;

    this.verificarAutenticidadeService.verificarAutenticidade(codigo, this.modulo).subscribe({
      next: (resultado: any) => {
        this.verificandoLoading = false;
        this.resultadoVisible = true;

        if (resultado.success && resultado.valido) {
          this.declaracaoValida = true;
          this.detalhesVerificacao = resultado;
        } else {
          this.declaracaoValida = false;
          this.detalhesVerificacao = null;
        }
      },
      error: (error) => {
        console.error(error);
        this.verificandoLoading = false;
        this.resultadoVisible = true;
        this.declaracaoValida = false;
        this.snackBar.showSnackBarError(error?.error?.message || 'Erro ao verificar autenticidade');
      }
    });
  }

  downloadDeclaracao() {
    const codigo = this.verificacaoForm.get('codigo').value;
    this.downloadLoading = true;

    this.verificarAutenticidadeService.downloadPdf(codigo, this.modulo).subscribe({
      next: (resultado: any) => {
        this.downloadLoading = false;

        if (resultado.success) {
          const binaryData = atob(resultado.pdf);
          const len = binaryData.length;
          const buffer = new ArrayBuffer(len);
          const view = new Uint8Array(buffer);
          for (let i = 0; i < len; i++) {
            view[i] = binaryData.charCodeAt(i);
          }
          const pdfBlob = new Blob([view], { type: 'application/pdf' });
          const url = URL.createObjectURL(pdfBlob);
          const link = document.createElement('a');
          link.href = url;
          link.download = resultado.fileName;
          link.click();
          setTimeout(() => {
            URL.revokeObjectURL(url);
            link.remove();
          }, 100);
        } else {
          this.snackBar.showSnackBarError('Não foi possível gerar o PDF');
        }
      },
      error: (error) => {
        console.error(error);
        this.downloadLoading = false;
        this.snackBar.showSnackBarError(error?.error?.message || 'Erro ao gerar PDF');
      }
    });
  }

  limparFormulario() {
    this.verificacaoForm.patchValue({ codigo: null });
    this.resultadoVisible = false;
  }
}
